import React from 'react';
import ContributionsForm from './ContributionsForm';

const EditContributionPage = () => {
    return <ContributionsForm formType="edit" />;
};

export default EditContributionPage;
